import { render, staticRenderFns } from "./CheckboxEditor.vue?vue&type=template&id=4caed0f2"
import script from "./CheckboxEditor.vue?vue&type=script&lang=js"
export * from "./CheckboxEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports